export default __webpack_public_path__ + "static/media/Constellation_002.e3abe317.jpg";